'use client';

import { createContext } from 'react';

import type { TextButtonRootContextInterface } from '../types/text-button-root.types';

export const TextButtonRootContext = createContext<TextButtonRootContextInterface>({});

TextButtonRootContext.displayName = 'TextButton.Root.Context';
